module.exports = __webpack_public_path__ + "img/uneffect.82c19edc.png";